export default function Stats() {
  const logos = [
    "BIOPHOTONICS",
    "REGEN ∙ LAB",
    "PHOTOMED",
    "CELL.SYS",
    "QUANTUM BIO",
    "AUREUS",
    "MERIDIAN",
  ];
  return (
    <section
      data-testid="stats-section"
      className="relative py-12 border-y border-white/5 bg-[#030508]/55 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center gap-10">
        <div className="hidden md:block flex-shrink-0">
          <p className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-white/40">
            Trusted by labs
            <br />
            & wellness pros
          </p>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex gap-16 marquee-track">
            {[...logos, ...logos].map((l, i) => (
              <div
                key={i}
                className="font-display font-black text-xl md:text-2xl text-white/30 tracking-tight whitespace-nowrap hover:text-[#00F0FF] transition-colors"
              >
                {l}
              </div>
            ))}
          </div>
          <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-[#030508] to-transparent" />
          <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-[#030508] to-transparent" />
        </div>
      </div>
    </section>
  );
}
